import { debounce } from 'lodash-es'
import { useDefaultModal } from '../defaultModal'
import Cover from './cover.vue'

export const useCustomCover = debounce(
  (
    record: Record<string, any>,
    success?: () => void,
    interceptSuccess?: (link: string) => void
  ) => {
    const { $t } = useNuxtApp()
    const videoUrl = record.video_url || record.url?.[0]
    if (!videoUrl) {
      message.info($t('shi-pin-bu-cun-zai'))
      return
    }
    const cancel = () => modal.destroy()
    const modal = useDefaultModal({
      closable: true,
      footer: false,
      title: $t('zi-ding-yi-feng-mian'),
      width: 952,
      okText: $t('she-wei-feng-mian'),
      content: (
        <Cover
          id={record.id}
          videoUrl={videoUrl}
          modelType={record.model_type}
          cancel={cancel}
          success={success}
          interceptSuccess={interceptSuccess}
        />
      ),
    })
  },
  200
)
